// extracted by mini-css-extract-plugin
export default {"wrapper":"d0g6C","label":"gKgvr","hasError":"a0XwJ","error":"qjZwt","input":"QScb2"};